export function getLanguageFromLocale(locale) {
  return locale?.split("-")?.[0];
}
